module.exports = __webpack_public_path__ + "static/img/YQtu2@2x.074c2c55.png";